module.exports = __webpack_public_path__ + "static/67625231_279636212907784_8503057471005261824_n-93c8ab25e6b5345a36d10a1b4d0f881c.jpg";